import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { IClinicalSubCategory, IClinicalSubCategoryListRequest } from "./iclinical-sub-category";

@Injectable({ providedIn: 'root' })
export class ClinicalSubCategoryService {
    private _subcategory: BehaviorSubject<IClinicalSubCategory | null> = new BehaviorSubject<IClinicalSubCategory | null>(null);
    private _subcategories: BehaviorSubject<IClinicalSubCategory[]> = new BehaviorSubject<IClinicalSubCategory[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get subcategory$(): Observable<IClinicalSubCategory | null> {
        return this._subcategory.asObservable();
    }

    get subcategories$(): Observable<IClinicalSubCategory[]> {
        return this._subcategories.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }



    getSubCategory(subcategoryData: IClinicalSubCategoryListRequest): Observable<BaseRespone<{ pagination: PaginationResult; clinicalSubCategories: IClinicalSubCategory[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; clinicalSubCategories: IClinicalSubCategory[] }>>(`${environment.baseURl}/ClinicalSubCategory/list`, subcategoryData).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._subcategories.next(response.result.clinicalSubCategories);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createSubcategory(subcategory: IClinicalSubCategory): Observable<BaseRespone<IClinicalSubCategory>> {
        return this._httpClient.post<BaseRespone<IClinicalSubCategory>>(`${environment.baseURl}/ClinicalSubCategory`, subcategory)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newsubcategory) => {
                    return newsubcategory;
                })
            )
    }

    updateSubcategory(subcategory: IClinicalSubCategory): Observable<BaseRespone<IClinicalSubCategory>> {
        return this.subcategories$.pipe(
            take(1),
            switchMap(subcategories => this._httpClient.put<BaseRespone<IClinicalSubCategory>>(`${environment.baseURl}/ClinicalSubCategory`, subcategory).pipe(
                map((updated: BaseRespone<IClinicalSubCategory>) => {

                    // Find the index of the updated product
                    const index = subcategories.findIndex(item => item.id === subcategory.id);

                    // Update the product
                    subcategories[index] = subcategory;

                    // Update the products
                    this._subcategories.next(subcategories);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    deleteSubcategory(id: number): Observable<BaseRespone<boolean>> {
        return this.subcategories$.pipe(
            take(1),
            switchMap(subcategory =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/ClinicalSubCategory/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const subcategorypatient = subcategory.filter(item => item.id !== id);
                            this._subcategories.next(subcategorypatient);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }
}
